<template>
  <resource-search
    search-context="user"
    :resource-props="{
      'is-read-only': false,
      'show-user': false
    }"
    :allow-all-tags="false"
    class="has-header-size-medium"
    v-if="currentUser"
  >
    <template v-slot:header>
      <div class="user-desktop">
        <user
          :user="currentUser"
          size="medium"
          show-name
          show-stats
          class="mb3"
        >
          <template v-slot:nextToUsername>
            <b-button
              v-if="userIsNotSelf(currentUser)"
              @click="toggleWatch"
              :type="isWatchingUser ? '' : 'is-primary'"
              :loading="$wait.is('toggeling watch')"
              size="is-small"
              class="ml3"
            >
              <nice-icon
                :icon="isWatchingUser ? 'eye-slash' : 'eye'"
                spacing-right
              ></nice-icon>
              {{ isWatchingUser ? "Stop watching" : "Watch" }}
            </b-button>
          </template>
        </user>
      </div>
      <div class="user-mobile">
        <user
          :user="currentUser"
          size="medium"
          show-name
          :show-stats="false"
          class="pv4"
        >
          <template v-slot:rightBottom>
            <b-button
              v-if="userIsNotSelf(currentUser)"
              @click="toggleWatch"
              :type="isWatchingUser ? '' : 'is-primary'"
              :loading="$wait.is('toggeling watch')"
              size="is-small"
            >
              <nice-icon
                :icon="isWatchingUser ? 'eye-slash' : 'eye'"
                spacing-right
              ></nice-icon>
              {{ isWatchingUser ? "Stop watching" : "Watch" }}
            </b-button>
          </template>
        </user>
      </div>
    </template>

    <template v-slot:headerDetails>
      <div class="header-details">
        <user
          :user="currentUser"
          size="medium"
          :show-name="false"
          show-stats
          :show-avatar="false"
        >
          <template v-slot:nextToUsername>
            <b-button
              v-if="userIsNotSelf(currentUser)"
              @click="toggleWatch"
              :type="isWatchingUser ? '' : 'is-primary'"
              :loading="$wait.is('toggeling watch')"
              size="is-small"
            >
              <nice-icon
                :icon="isWatchingUser ? 'eye-slash' : 'eye'"
                spacing-right
              ></nice-icon>
              {{ isWatchingUser ? "Stop watching" : "Watch" }}
            </b-button>
          </template>
        </user>
      </div>
    </template>

    <template v-slot:empty>
      <b-message v-if="currentUser">
        Seems like {{ currentUser.username }} has no public resources.
      </b-message>
    </template>
  </resource-search>
</template>

<script>
import ResourceSearch from "@/components/resource/Search.vue";

export default {
  components: {
    ResourceSearch
  },

  data() {
    return {};
  },

  methods: {
    async toggleWatch() {
      this.$wait.start("toggeling watch");
      if (this.isWatchingUser) {
        await this.$store.dispatch("user/unwatchUser");
      } else {
        await this.$store.dispatch("user/watchUser");
      }
      this.$wait.end("toggeling watch");
    },

    async load(username) {
      this.$wait.start("loading.user");
      this.$store.commit("user/RESET_DEFAULT");
      this.$store.commit("user/default/SET_PAGE", 0);

      const user = await this.$store.dispatch("user/fetchUser", {
        username: username
      });

      // this.$store.commit('user/SET_CURRENT_ID', username)

      await Promise.all([
        // this.$store.dispatch('user/fetchUser', { username: username }),
        this.$store.dispatch("user/fetchTags"),
        this.$store.dispatch("user/default/fetchResources")
      ]);

      this.$wait.end("loading.user");
    }
  },

  computed: {
    isWatchingUser() {
      return (
        this.currentUser &&
        this.$user &&
        !!this.$user.watching.find(u => u.id === this.currentUser.id)
      );
    },
    currentUser() {
      return this.$store.getters["user/current"];
    }
  },

  watch: {
    initAndContextAndActivated: {
      immediate: true,
      async handler(val) {
        if (val) {
          this.load(this.$route.params.username);
        }
      }
    }
  },

  beforeRouteUpdate(to, from, next) {
    if (to.username !== from.username) this.load(to.params.username);
    next();
  },

  created() {
    this.isActivated = true;
  },
  beforeDestroy() {
    this.isActivated = false;
    this.$store.commit("user/SET_CURRENT_ID", null);
  }
};
</script>

<style lang="scss" scoped>
.header-details,
.user-mobile {
  display: block;

  @include desktop() {
    display: none;
  }
}

.user-desktop {
  display: none;

  @include desktop() {
    display: block;
  }
}
</style>
